import React, { Component } from "react";

import { CButton, CSpinner, CLabel } from "@coreui/react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  FormGroup
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import ContentComponentActivity from "../Content/ContentActivity";
import FileCreator from "../Content/FileCreator";
import LinkCreator from "../Content/LinkCreator";
import UploadCreator from "../Content/UploadCreator";
import ModalActivity from "../Modal/ModalActivity";
import QuestionListImportModal from "../QuestionListImportModal/QuestionListImportModal";
import Uploader from "../Uploader/uploader";

import "./css/resource.css";

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Moves an item from one list to another list.
 */

const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

const grid = 8;

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: grid,
  width: "100%",
  display: "flex",
  justifyContent: "start",
  flexFlow: "wrap",
  border: "1px solid #d8dbe0",
  borderRadius: "0.25rem"
});
const getListStyleOrderOnly = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: grid,
  width: "100%",
  display: "flex",
  flexDirection: "column"
});
const dropeListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: grid,
  width: "100%",
  display: "flex",
  justifyContent: "start",
  border: "2px dashed #d8dbe0",
  borderRadius: "0.25rem",
  minHeight: "160px"
});

class DragAndDropLive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selected: [],
      modal: false,
      modalProps: {
        modalCompoent: 1, // 1- content , 2-question
        title: "",
        type: 0,
        typeName: ""
      },
      linkModal: false,
      uploadModal: false,
      fileModal: false,
      loading: true,
      discipline_id: this.props.discipline,
      notReleased: [],
      overrideRelease: false,
      textProduction: {
        id: "",
        name: "",
        group: false,
        type: "",
        criterion: [],
        note: 0
      },
      criterions: [],
      newTextProductionCriterion: "",
      textTypes: []
    };
  }

  id2List = {
    droppable: "items",
    droppable2: "selected"
  };

  componentDidMount() {
    let objCriterionsList = {
      user_id: this.props.user.user.id
    };

    axios
      .all([
        axios.get(`${URL.api}content/type/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(
          `${URL.api}activity/activity/singleView/${this.props.activity}?allocation_id=${this.props.allocation_id}`,
          { headers: { authorization: `Bearer ${this.props.user.token}` } }
        ),
        axios.get(`${URL.api}literarte/text_types`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}literarte/criterions`, objCriterionsList, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread(
          (respType, respActivity, respTextTypes, respTextCriterions) => {
            if (respType.data.success && respActivity.data.success) {
              let textTypesList = [];
              respTextTypes.data.data.forEach(type => {
                textTypesList.push(type);
              });

              let textCriterionsList = [];
              respTextCriterions.data.data[0].forEach(criterion => {
                criterion.visible = true;
                textCriterionsList.push(criterion);
              });

              respTextCriterions.data.data[1].forEach(criterion => {
                criterion.visible = true;
                textCriterionsList.push(criterion);
              });

              let types = [];

              respType.data.data.forEach(type => {
                if (type.activity === true) {
                  if (type.name === "Avaliação") {
                    type.name = "Exercício";
                  }

                  if (
                    type.id === 9 &&
                    this.props.user.user_modules?.find(
                      module => module.id === 11
                    )
                  ) {
                    types.push(type);
                  } else if (
                    this.props.user.user_modules?.find(
                      module => module.id === 2
                    )
                  ) {
                    types.push(type);
                  } else if (type.id === 18 || type.id === 12) {
                    types.push(type);
                  }
                }
              });

              let contentList = [];

              respActivity.data.data.items.forEach(item => {
                let obj = {
                  type: item.type_id,
                  list: {
                    id: item.obj_id,
                    name: item.name
                  },
                  link: item.link
                };

                contentList.push(obj);
              });

              let items = types;

              items.forEach((elem, idx) => {
                items[idx].content = elem.name;
              });

              this.setState({
                types,
                contentList,
                items,
                criterions: textCriterionsList,
                textTypes: textTypesList,
                loading: false
              });
            }
          }
        )
      );
  }

  getList = id => this.state[this.id2List[id]];

  onDragEnd = result => {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }
    let draggedItem = result.draggableId;

    let target = result.destination.droppableId;

    if (
      source.droppableId === destination.droppableId &&
      source.droppableId === "droppable2"
    ) {
      // just order
      let contentList = [];
      this.state.contentList.forEach(item => {
        contentList.push(item);
      });

      contentList = reorder(contentList, source.index, destination.index);

      this.getOrder(contentList);
    } else if (source.droppableId !== destination.droppableId) {
      // select
      let list = this.getList(source.droppableId);
      list.forEach(item => {
        if (item.id === draggedItem) {
          draggedItem = item;
        }
      });
      const result = move(
        this.getList(source.droppableId),
        this.getList(destination.droppableId),
        source,
        destination
      );
      if (this.props.dontChangeListOnSelect) {
        this.setState(
          {
            selected: result.droppable2
          },
          () => {
            if (target === "droppable2") {
              this.selectedItem(draggedItem);
            }
            this.getSelected(this.state.selected);
          }
        );
      } else {
        this.setState(
          {
            items: result.droppable,
            selected: result.droppable2
          },
          () => {
            if (target === "droppable2") {
              this.selectedItem(draggedItem);
            }
            this.getSelected(this.state.selected);
          }
        );
      }
    }
  };

  selectChange = item => {
    let { items } = this.state;
    items.forEach((selected, idx) => {
      if (item.id === selected.id) {
        if (selected.checked) {
          items[idx].checked = false;
        } else {
          items[idx].checked = true;
        }
      }
    });

    this.setState({ items });

    this.props.getChecked(item);
  };

  getOrder = order => {
    this.setState({ contentList: order });
  };

  getSelected = selected => {
    this.setState({ selected });
  };

  selectedItem = (item, overrideRelease = false) => {
    if (item.id <= 12 || item.id === 14) {
      this.setState(
        {
          modalProps: {
            // eslint-disable-next-line react/no-access-state-in-setstate
            ...this.state.modalProps,
            modalCompoent: 1,
            type: item.id,
            typeName: item.name,
            title: `Selecione - ${item.name}`
          },
          overrideRelease
        },
        () => {
          this.toggleModal();
        }
      );
    } else if (item.id === 17) {
      this.setState({ fileModal: true });
    } else if (item.id === 16) {
      this.setState({ linkModal: true });
    } else if (item.id === 18) {
      this.setState({ uploadModal: true });
    } else if (item.id === 23) {
      this.getContent(
        {
          type: item.id,
          list: [
            {
              id: item.id,
              name: item.name
            }
          ]
        },
        false
      );
    } else if (this.state.editing) {
      this.setState({ editing: false });
    } else {
      this.setState(state => ({
        notReleased: [...state.notReleased, { id: -1, type: item.id }],
        contentList: [
          ...state.contentList,
          { type: item.id, list: { id: -1, name: item.name } }
        ]
      }));
    }
  };

  removeItem = (type, id) => {
    let contentList = [];
    this.state.contentList.forEach(item => {
      if (item.type !== type || item.list.id !== id) {
        contentList.push(item);
      } else if (
        this.state.notReleased.findIndex(
          item => item.id === id && item.type === type
        ) === -1
      ) {
        this.props.onRemove({
          title: item.list.name,
          subtitle: this.state.items.find(
            stateItem => stateItem.id === item.type
          ).name,
          type_icon:
            item.type === 23
              ? "video-camera"
              : this.state.items.find(stateItem => stateItem.id === item.type)
                  .icon,
          type_color:
            item.type === 23
              ? "dark"
              : this.state.items.find(stateItem => stateItem.id === item.type)
                  .color,
          type_id: item.type,
          obj_id: item.list.id,
          name: item.list.name
        });
      }
    });

    this.setState({ contentList });
  };

  toggleModal = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      modal: !this.state.modal
    });
  };

  releaseItem(obj) {
    this.props.onInsert({
      title: obj.list.name,
      subtitle: this.state.items.find(item => item.id === obj.type).name,
      type_icon:
        obj.type === 23
          ? "video-camera"
          : this.state.items.find(item => item.id === obj.type).icon,
      type_color:
        obj.type === 23
          ? "dark"
          : this.state.items.find(item => item.id === obj.type).color,
      type_id: obj.type,
      obj_id: obj.list.id,
      name: obj.list.name
    });

    this.setState(state => ({
      notReleased: state.notReleased.filter(
        notReleasedItem =>
          notReleasedItem.id !== obj.list.id ||
          notReleasedItem.type !== obj.type
      )
    }));
  }

  selectedListItem = list => {
    let { id, name } = list;
    let contentList = [];
    this.state.contentList.forEach(list => {
      contentList.push(list);
    });

    let check = true;
    for (let i = 0; i < contentList.length; i++) {
      if (contentList[i].list.id === id && contentList[i].type === 12) {
        check = false;
        toastr.error(
          "Erro",
          `A lista "${name}" já tinha sido adicionada antes.`
        );
        break;
      }
    }

    let obj = {
      type: 12,
      list: {
        id,
        name
      }
    };

    if (check) {
      contentList.push(obj);

      if (this.state.overrideRelease) {
        this.releaseItem(obj);
      } else {
        this.setState(state => ({
          notReleased: [
            ...state.notReleased,
            { id: obj.list.id, type: obj.type }
          ]
        }));
      }
    }

    this.setState(
      {
        contentList
      },
      () => {
        this.toggleModal();
      }
    );
  };

  getContent = (content, toggleModal = true) => {
    let contentList = [];
    this.state.contentList.forEach(list => {
      contentList.push(list);
    });

    for (let i = 0; i < content.list.length; i++) {
      let check = true;
      let obj = {
        type: content.type,
        list: content.list[i]
      };

      for (let j = 0; j < contentList.length; j++) {
        if (
          content.type === contentList[j].type &&
          content.list[i].id === contentList[j].list.id
        ) {
          check = false;
          toastr.error(
            "Erro",
            `O conteúdo "${content.list[i].name}" já tinha sido adicionado antes.`
          );
          break;
        }
      }

      if (check) {
        contentList.push(obj);

        this.setState(state => ({
          notReleased: [
            ...state.notReleased,
            { id: obj.list.id, type: obj.type }
          ]
        }));
      }
    }

    this.setState(
      {
        contentList
      },
      () => {
        if (toggleModal) {
          this.toggleModal();
        }
      }
    );
  };

  // ajusteMarvin ajustar id do objeto (verificar como vai ser feito) (verificar se vai salvar no banco)
  doneArchive = uploads => {
    let contentList = [];
    this.state.contentList.forEach(list => {
      contentList.push(list);
    });

    let obj = {
      type: 17,
      list: {
        id: uploads.split("/").reverse()[1].toLowerCase() === "repo" ? 0 : 1,
        name: uploads.split("/").reverse()[0]
      },
      link: uploads
    };

    contentList.push(obj);

    this.setState(state => ({
      notReleased: [...state.notReleased, { id: obj.list.id, type: obj.type }]
    }));

    this.setState({
      contentList
    });
  };

  changeTextProductionName = e => {
    let { value } = e.target;
    this.setState({
      textProduction: {
        // eslint-disable-next-line react/no-access-state-in-setstate
        ...this.state.textProduction,
        name: value
      }
    });
  };

  changeTextProductionNote = e => {
    let { value } = e.target;
    this.setState({
      textProduction: {
        // eslint-disable-next-line react/no-access-state-in-setstate
        ...this.state.textProduction,
        note: value
      }
    });
  };

  changeTextProductionCriterionNote = (e, i) => {
    let { value } = e.target;

    let criterions = [];
    this.state.textProduction.criterion.forEach((criterion, index) => {
      if (i === index) {
        criterion.note = value;
      }
      criterions.push(criterion);
    });

    this.setState({
      textProduction: {
        // eslint-disable-next-line react/no-access-state-in-setstate
        ...this.state.textProduction,
        criterion: criterions
      }
    });
  };

  changeTextProductionCriterion = e => {
    let { value } = e.target;

    let criterions = [];
    this.state.textProduction.criterion.forEach(criterion => {
      criterions.push(criterion);
    });

    let criterionsState = [];
    this.state.criterions.forEach(criterion => {
      criterionsState.push(criterion);
      if (criterion.id === parseInt(value)) {
        criterion.note = 0;
        criterions.push(criterion);
        criterionsState[criterionsState.length - 1].visible = false;
      }
    });

    this.setState({
      criterions: criterionsState,
      textProduction: {
        // eslint-disable-next-line react/no-access-state-in-setstate
        ...this.state.textProduction,
        criterion: criterions
      }
    });
  };

  removeTextProductionCriterion = id => {
    let criterions = [];
    this.state.textProduction.criterion.forEach(criterion => {
      if (criterion.id !== id) {
        criterions.push(criterion);
      }
    });

    let criterionsState = [];
    this.state.criterions.forEach(criterion => {
      criterionsState.push(criterion);
      if (criterion.id === id) {
        criterionsState[criterionsState.length - 1].visible = true;
      }
    });

    this.setState({
      criterions: criterionsState,
      textProduction: {
        // eslint-disable-next-line react/no-access-state-in-setstate
        ...this.state.textProduction,
        criterion: criterions
      }
    });
  };

  createTextProduction = () => {
    let check = true;
    if (this.state.textProduction.name === "") {
      toastr.error("Erro", "O campo título não pode ser vazio.");
      check = false;
    }

    if (this.state.textProduction.note === 0) {
      toastr.error("Erro", "O campo nota não pode ser 0.");
      check = false;
    }

    if (this.state.textProduction.type === "") {
      toastr.error("Erro", "O campo tipo não pode ser vazio.");
      check = false;
    }

    if (this.state.textProduction.criterion.length === 0) {
      toastr.error("Erro", "O campo critério não pode ser vazio.");
      check = false;
    }

    let count = 0;
    this.state.textProduction.criterion.forEach(criterion => {
      count += Number(criterion.note.toString().replace(",", "."));
    });

    if (
      count !==
      Number(this.state.textProduction.note.toString().replace(",", "."))
    ) {
      toastr.error(
        "Erro",
        "A soma das notas dos critérios tem que ser igual a nota geral."
      );
      check = false;
    }

    if (check) {
      let obj = {
        user_id: this.props.user.user.id,
        title: this.state.textProduction.name,
        text_type_id: this.state.textProduction.type,
        note: this.state.textProduction.note,
        criterions: this.state.textProduction.criterion
      };

      axios
        .post(`${URL.api}literarte/activity_create`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          if (resp.data.success) {
            let contentList = [];
            this.state.contentList.forEach(content => {
              contentList.push(content);
            });

            contentList.push({
              type: 14,
              list: {
                id: resp.data.data,
                name: this.state.textProduction.name
              }
            });

            this.setState(state => ({
              notReleased: [
                ...state.notReleased,
                { id: resp.data.data, type: 14 }
              ]
            }));

            this.setState(
              {
                textProduction: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.textProduction,
                  id: resp.data.data
                },
                contentList
              },
              () => {
                this.toggleModal();
              }
            );
          }
        });
    }
  };

  render() {
    let time = new Date().getTime();

    return (
      <div className="w-100">
        {this.state.loading ? (
          <div
            className="d-flex align-items-center justify-content-center w-100 mb-3"
            style={{ height: "400px" }}
          >
            <CSpinner size="lg" color="secondary" />
          </div>
        ) : (
          <DragDropContext
            onDragEnd={this.onDragEnd}
            className="warpTypeResources"
          >
            <Droppable droppableId="droppable" direction={this.props.direction}>
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  style={
                    this.props.orderOnly
                      ? getListStyleOrderOnly(snapshot.isDraggingOver)
                      : getListStyle(snapshot.isDraggingOver)
                  }
                >
                  {this.state.items.map((item, index) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          key={item.id}
                          className={
                            this.props.orderOnly ? "orderContent" : "typeBox"
                          }
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <div className="warp-item-dnd">
                            {this.props.checkbox ? (
                              <div>
                                <FormGroup className="filterCheckBox dndCheckBox">
                                  <InputGroup>
                                    <Input
                                      placeholder="select"
                                      onChange={e => this.selectChange(item)}
                                      checked={item.checked}
                                      type="checkbox"
                                    />
                                  </InputGroup>
                                </FormGroup>
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="w-100 h-100">
                              <div className="typeContent">
                                {!this.props.orderOnly ? (
                                  item.icon ? (
                                    <div
                                      className={`typeIcon bg-${item.color}`}
                                    >
                                      <i className={`fa fa-${item.icon}`}></i>
                                    </div>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )}
                                <div className="typeTitle text-ellipsis">
                                  {item.content}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
            {this.props.dropArea ? (
              <div>
                <div className="mt-3 mb-2">{this.props.dropName}</div>
                <Droppable
                  droppableId="droppable2"
                  direction={this.props.direction}
                >
                  {(provided, snapshot) => (
                    <div
                      key={`${time}droppable2`}
                      ref={provided.innerRef}
                      style={dropeListStyle(snapshot.isDraggingOver)}
                    >
                      {this.state.contentList.map((item, index) => (
                        <Draggable
                          key={index}
                          draggableId={`${item.type}-${item.list.id}-selected-${time}`}
                          isDragDisabled
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              key={`${item.type}-${item.list.id}-${time}`}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className={
                                item.type !== 23 ? "typeBox editable" : "off"
                              }
                            >
                              {item.type !== 23 && (
                                <>
                                  <CButton
                                    color="secondary"
                                    className="typeCloseButton"
                                    onClick={() =>
                                      this.removeItem(item.type, item.list.id)
                                    }
                                  >
                                    <i className="fa fa-close"></i>
                                  </CButton>
                                </>
                              )}
                              {this.state.notReleased.findIndex(
                                notReleasedItem =>
                                  notReleasedItem.id === item.list.id &&
                                  notReleasedItem.type === item.type
                              ) !== -1 && (
                                <CButton
                                  color="primary"
                                  className="typeReleaseButton"
                                  onClick={() => this.releaseItem(item)}
                                >
                                  Liberar
                                </CButton>
                              )}
                              <div
                                className="typeContent"
                                style={{
                                  opacity:
                                    this.state.notReleased.findIndex(
                                      notReleasedItem =>
                                        notReleasedItem.id === item.list.id &&
                                        notReleasedItem.type === item.type
                                    ) !== -1
                                      ? 0.25
                                      : 1
                                }}
                              >
                                <div
                                  className={`typeIcon bg-${
                                    item.type === 23
                                      ? "dark"
                                      : this.state.items.find(
                                          type => type.id === item.type
                                        ).color
                                  }`}
                                >
                                  <i
                                    className={`h-auto fa fa-${
                                      item.type === 23
                                        ? "video-camera"
                                        : this.state.items.find(
                                            type => type.id === item.type
                                          ).icon
                                    }`}
                                  ></i>
                                </div>
                                <div className="typeTitle text-ellipsis">
                                  {item.list.name}
                                </div>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            ) : (
              ""
            )}
          </DragDropContext>
        )}
        <UploadCreator
          show={this.state.uploadModal}
          onClose={() => this.setState({ uploadModal: false })}
          getContent={content => this.getContent(content, false)}
        />
        <LinkCreator
          show={this.state.linkModal}
          onClose={() => this.setState({ linkModal: false })}
          getContent={content => this.getContent(content, false)}
        />
        {this.state.fileModal && (
          <FileCreator
            show
            onClose={() => this.setState({ fileModal: false, editing: false })}
            doneArchive={content => this.doneArchive(content)}
          />
        )}
        <ModalActivity
          toggleModal={this.toggleModal}
          modalState={this.state.modal}
          title={this.state.modalProps.title}
          className=" educandus modalActivity"
          backdrop="static"
          size="xl"
          noFooter
        >
          {this.state.modalProps.type < 12 ? (
            <ContentComponentActivity
              discipline={this.state.discipline_id}
              type={this.state.modalProps.type}
              typeName={this.state.modalProps.typeName}
              typeColor={
                this.state.items.find(
                  type => type.id === this.state.modalProps.type
                )?.color
              }
              typeIcon={
                this.state.items.find(
                  type => type.id === this.state.modalProps.type
                )?.icon
              }
              activity
              getContent={content => this.getContent(content)}
              currentRoute={this.props.currentRoute}
            />
          ) : (
            ""
          )}
          {this.state.modalProps.type === 12 ? (
            <QuestionListImportModal
              selectedListChanger={this.selectedListItem}
            />
          ) : (
            ""
          )}
          {this.state.modalProps.type === 14 ? (
            <>
              <FormGroup className="mb3">
                <CLabel>Título</CLabel>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-text-width" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    value={this.state.textProduction.name}
                    onChange={this.changeTextProductionName}
                    placeholder="Título do texto"
                  />
                </InputGroup>
              </FormGroup>

              <FormGroup className="mb3">
                <CLabel>Nota</CLabel>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-text-width" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="number"
                    value={this.state.textProduction.note}
                    onChange={e => this.changeTextProductionNote(e)}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup className="mb3">
                <CLabel>Tipo</CLabel>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-text-width" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="select"
                    value={this.state.textProduction.type}
                    onChange={e =>
                      this.setState({
                        textProduction: {
                          // eslint-disable-next-line react/no-access-state-in-setstate
                          ...this.state.textProduction,
                          type: e.target.value
                        }
                      })
                    }
                  >
                    <option value="">Escolha o tipo</option>
                    {this.state.textTypes.map(type => (
                      <React.Fragment key={type.id}>
                        <option value={type.id}>{type.name}</option>
                      </React.Fragment>
                    ))}
                  </Input>
                </InputGroup>
              </FormGroup>
              <FormGroup className="mb3">
                <CLabel>Critérios</CLabel>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-text-width" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="select"
                    defaultValue=""
                    onChange={this.changeTextProductionCriterion}
                  >
                    <option value="">Escolha um critério</option>
                    <optgroup label="Critérios do sistema">
                      {this.state.criterions.map(criterion => (
                        <React.Fragment key={criterion.id}>
                          {criterion.visible && criterion.user_id === null ? (
                            <React.Fragment key={criterion.id}>
                              <option value={criterion.id}>
                                {criterion.name}
                              </option>
                            </React.Fragment>
                          ) : null}
                        </React.Fragment>
                      ))}
                    </optgroup>
                    <optgroup label="Critérios do usuário">
                      {this.state.criterions.map(criterion => (
                        <React.Fragment key={criterion.id}>
                          {criterion.visible &&
                          criterion.user_id === this.props.user.user.id ? (
                            <React.Fragment key={criterion.id}>
                              <option value={criterion.id}>
                                {criterion.name}
                              </option>
                            </React.Fragment>
                          ) : null}
                        </React.Fragment>
                      ))}
                    </optgroup>
                  </Input>
                </InputGroup>
              </FormGroup>
              <FormGroup className="mb3">
                <CLabel>Adicione um critério que não existe</CLabel>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fa fa-text-width" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    value={this.state.newTextProductionCriterion}
                    onChange={this.changeNewTextProductionCriterion}
                    placeholder="Digite o novo critério aqui"
                  />
                  <CButton
                    color="primary"
                    onClick={() => this.createTextProductionCriterion()}
                  >
                    Adicionar
                  </CButton>
                </InputGroup>
              </FormGroup>
              <FormGroup className="mb3">
                <h3>Critérios escolhidos</h3>
                {this.state.textProduction.criterion.map((criterion, index) => (
                  <div key={criterion.id} style={{ flexDirection: "row" }}>
                    <div style={{ flexDirection: "row" }}>
                      {`- ${criterion.name} `}
                      <i
                        className="fa fa-remove"
                        style={{ color: "#F00", cursor: "pointer" }}
                        onClick={() =>
                          this.removeTextProductionCriterion(criterion.id)
                        }
                      ></i>
                    </div>
                    <div>
                      <FormGroup className="mb3">
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="fa fa-text-width" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="number"
                            value={criterion.note}
                            onChange={e =>
                              this.changeTextProductionCriterionNote(e, index)
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                    </div>
                  </div>
                ))}
              </FormGroup>
              <CButton
                color="primary"
                onClick={() => this.createTextProduction()}
              >
                Criar
              </CButton>
            </>
          ) : (
            ""
          )}
          {this.state.modalProps.type === 17 ? (
            <Uploader
              type="activity"
              maxFiles={1}
              allowMultiple
              labelIdle="Clique aqui ou arraste um arquivo para cá"
              done={uploads => this.doneArchive(uploads)}
            />
          ) : (
            ""
          )}
        </ModalActivity>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
})(DragAndDropLive);
